module.exports = __webpack_public_path__ + "img/sporting-cp.41e1095c.png";